import React, { useState } from "react";
import { Popover, Badge, Empty } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { cn } from "src/util/cn";

interface Notification {
  id: string;
  title: string;
  message: string;
  timestamp: Date;
  read: boolean;
}

export const NotificationPopover: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  
  // Stub data - replace with actual notification state management
  const [notifications] = useState<Notification[]>([]);
  const unreadCount = notifications.filter((n) => !n.read).length;

  const handleMarkAllRead = () => {
    // Implement mark all as read logic
    console.log("Mark all read");
  };

  const popoverContent = (
    <div className="w-[382px]">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <span className="font-semibold text-base">
          {t("dashboard.header.notifications")}
        </span>
        {unreadCount > 0 && (
          <span
            className="text-sm text-[#3867d6] cursor-pointer hover:underline"
            onClick={handleMarkAllRead}
          >
            {t("dashboard.header.mark_all_read")}
          </span>
        )}
      </div>
      <div className="max-h-[400px] overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="py-8 px-4">
            <Empty
              description={t("dashboard.header.no_notifications")}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className={cn(
                  "px-4 py-3 cursor-pointer hover:bg-gray-50",
                  !notification.read && "bg-blue-50"
                )}
              >
                <p className="font-medium text-sm m-0 mb-1">{notification.title}</p>
                <p className="text-xs text-gray-600 m-0">{notification.message}</p>
                <p className="text-xs text-gray-400 mt-1 m-0">
                  {notification.timestamp.toLocaleString()}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      trigger="click"
      placement="bottomRight"
      open={isVisible}
      onOpenChange={setIsVisible}
    >
      <Badge count={unreadCount} offset={[-5, 5]}>
        <BellOutlined className="text-xl text-[#7D878C] cursor-pointer" />
      </Badge>
    </Popover>
  );
};

export default NotificationPopover;
